import { render } from "./index.vue?vue&type=template&id=034951df&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=034951df&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-034951df"

export default script